import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from "react-i18next"
import ScrollBox from '../../../components/ScrollBox'
import { formatINRCurrency } from '../../../utils/format'
import UnderLineTxt2 from '../../../components/UnderLineTxt2'

function ViewConsolidatedBreakup({open, onClose, trkOpReqId, consBreakupData}) {
  //console.log("Modal open:", open);
  //console.log("Consolidated Breakup Data:", consBreakupData);

  const { t } = useTranslation()
  

  const boxStyle = {
    bgcolor: "rgba(0, 0, 0, 0.05)",
    borderRadius: 10,
    fontWeight: "600"
  }
  const totalFinalPrice = consBreakupData?.totalFinalPrice ?? 0;
  const additions = consBreakupData?.totalAdditions ?? 0;
  const deductions = consBreakupData?.totalDeductions ?? 0;
  const  shipmentFinalPrice= consBreakupData?.shipmentFinalPrice ?? 0;


  return (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Stack direction="row" alignItems="center" mb={1}>
          <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>{t("bo.priceDet.consolPrcDet")}</Typography>
          <Typography sx={{ fontWeight: "bold", fontSize: 16, color: "rgba(0, 0, 0, 0.3)" }}>({trkOpReqId})</Typography>
        </Stack>

        {/* BODY */}
        <ScrollBox height="85%">
          <Stack alignItems="center">
            <UnderLineTxt2
              boxStyle={boxStyle}
              label={t("Shipment Price")}
              value={formatINRCurrency(totalFinalPrice)}
              line
            />
            <UnderLineTxt2
              boxStyle={boxStyle}
              label={t("Additions")}
              value={formatINRCurrency(additions)}
              line
            />
            <UnderLineTxt2
              boxStyle={boxStyle}
              label={t("Deductions")}
              value={formatINRCurrency(deductions)}
              line
            />
            <UnderLineTxt2
              boxStyle={boxStyle}
              label={t("Shipment Final Price")}
              value={formatINRCurrency(shipmentFinalPrice)}
              line
            />

          </Stack>
        </ScrollBox>

        {/* FOOTER */}
        <Stack direction="row" justifyContent="flex-end" mt={2}>
          <Button variant="contained" sx={{ width: 120 }} onClick={onClose}>
            {t("bo.priceDet.close")}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default ViewConsolidatedBreakup

export function StyleBox({ label, value }) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        border: '2px solid #0D47A1',
        backgroundColor: '#E3F2FD',
        borderRadius: '16px',
        padding: 2,
        width: "100%",
        mb: 1
      }}
    >
      <Typography fontWeight="bold" color="#0D47A1">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        {value}
      </Typography>
    </Stack>
  )
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 590,
  bgcolor: 'background.paper',
  boxShadow: 24,
  px: 3,
  py: 2,
  borderRadius: 2,
  height: "90%"
}
